export default "__VITE_ASSET__HT$9tCwI__"